import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PersonalInfoForm } from '@/components/shared/components/forms/PersonalInfoForm';
import { PersonalInfo } from '@/types';

interface ProfileDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: Omit<PersonalInfo, 'id'>) => void;
  initialData?: PersonalInfo;
  mode: 'add' | 'edit';
}

export function ProfileDialog({
  open,
  onClose,
  onSubmit,
  initialData,
  mode,
}: ProfileDialogProps) {
  const [formData, setFormData] = React.useState({
    fullName: initialData?.fullName || '',
    description: initialData?.description || '',
    photoUrl: initialData?.photoUrl || '',
    resumeUrl: initialData?.resumeUrl || '',
    isResumePublic: initialData?.isResumePublic || false,
    forSelf: true,
  });

  React.useEffect(() => {
    if (initialData) {
      setFormData({
        fullName: initialData.fullName,
        description: initialData.description,
        photoUrl: initialData.photoUrl || '',
        resumeUrl: initialData.resumeUrl || '',
        isResumePublic: initialData.isResumePublic,
        forSelf: true,
      });
    }
  }, [initialData]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>
            {mode === 'add' ? 'إضافة ملف شخصي' : 'تعديل الملف الشخصي'}
          </DialogTitle>
        </DialogHeader>

        {/* Preview Section */}
        {(formData.photoUrl || formData.fullName) && (
          <div className="bg-gray-50 rounded-lg p-4 mb-4">
            <div className="flex items-center gap-4">
              {formData.photoUrl && (
                <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-white">
                  <img
                    src={formData.photoUrl}
                    alt={formData.fullName}
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
              {formData.fullName && (
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold truncate">{formData.fullName}</h3>
                  {formData.description && (
                    <p className="text-sm text-gray-600 line-clamp-2">{formData.description}</p>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Form Section - Scrollable */}
        <div className="flex-1 overflow-y-auto">
          <PersonalInfoForm
            formData={formData}
            onChange={setFormData}
            onSubmit={handleSubmit}
            submitLabel={mode === 'add' ? 'إضافة' : 'حفظ التعديلات'}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}